export default __webpack_public_path__ + "static/media/ico_9.d91095d9.png";